import { render, staticRenderFns } from "./LoadListNew.vue?vue&type=template&id=60b8e302&scoped=true"
import script from "./LoadListNew.vue?vue&type=script&lang=js"
export * from "./LoadListNew.vue?vue&type=script&lang=js"
import style0 from "./LoadListNew.vue?vue&type=style&index=0&id=60b8e302&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b8e302",
  null
  
)

export default component.exports